import { render, staticRenderFns } from "./ChooseAssessmentDialog.vue?vue&type=template&id=681c2a68&scoped=true&"
import script from "./ChooseAssessmentDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseAssessmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c2a68",
  null
  
)

/* custom blocks */
import block0 from "./ChooseAssessmentDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports